"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDeprecatedButtonFont = exports.deprecatedTypeVariants = exports.deprecatedButtonPaddingTopBottom = exports.buttonSizesWithDeprecationWarning = void 0;
var buttonSizesWithDeprecationWarning = exports.buttonSizesWithDeprecationWarning = {
  /**
   * @deprecated
   * Use buttonSize="sm" instead.
   */
  sm: 'sm',
  /**
   * @deprecated
   * Use buttonSize="md" instead.
   */
  md: 'md',
  /**
   * @deprecated
   * Use buttonSize="lg" instead.
   */
  lg: 'lg'
};
var deprecatedTypeVariants = exports.deprecatedTypeVariants = {
  sm: 'finaleBold',
  md: 'violaBold',
  lg: 'balladBold'
};
var getDeprecatedButtonFont = exports.getDeprecatedButtonFont = function getDeprecatedButtonFont(buttonSize) {
  switch (buttonSize) {
    case 'small':
      return 'marginalBold';
    case 'medium':
      return 'bodySmallBold';
    case 'large':
      return 'bodyMediumBold';
    default:
      return 'bodySmallBold';
  }
};
var deprecatedButtonPaddingTopBottom = exports.deprecatedButtonPaddingTopBottom = {
  small: '8px' /* TODO: can we use an encore token here? */,
  medium: '14px' /* TODO: can we use an encore token here? */,
  large: '16px' /* TODO: can we use an encore token here? */
};